export const CRITERIA: {
  [key in string]: {
    isProjectOnly: boolean
    isFree: boolean
    showOutdated: boolean
    showInDudaEditor: boolean
    showExtraAdviceForDudaEditor: boolean
  }
} = {
  title: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  description: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  google_preview: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  headings: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  keywords_cloud: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  image_optimization: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  images: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  links_details: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  language: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  web_feeds: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  www_resolve: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  robots_txt: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  xml_sitemaps: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  sitemaps_validity: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  clean_url: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  canonical_tags: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  noindex_nofollow: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  robots_tags: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  hreflang: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  broken_links: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  underscores_url: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  indexed_pages: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  mobile_friendliness: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_rendering: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_taptargets: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  mobile_compatibility: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_fontsize: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  mobile_viewport: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  mobile_frameworks: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  amp: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  schema_org: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  open_graph: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  twitter_card: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  microformats: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  email_security: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  dmarc: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  ssl_secured: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  mixed_content: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  resources_minification: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  resources_compression: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  resources_cacheability: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  layout_shift_elements: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  largest_contentful_paint_element: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  accessibility_contrast: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  accessibility_navigation: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  accessibe: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  pj_uptime: {
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  ip_information: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  technologies: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  analytics_technologies: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  doctype: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  encoding: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  url: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  favicon: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  custom_404: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  domain_registration: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  tld_cybersquating_prevention: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  typo_cybersquating_prevention: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_score: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_counter: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  backlinks_ref_domains: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  pj_backlinks_quality: {
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_engagement: {
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_estimation: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_monthly_visits: {
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_popularity: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_sources: {
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  traffic_top_countries: {
    isProjectOnly: false,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  local_directories: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  local_online_reviews: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  shared_count: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  },
  facebook_brand_page: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  twitter_account: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  instagram: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  linkedin: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: true
  },
  crunchbase: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: false,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  discovered_social_profiles: {
    isProjectOnly: false,
    isFree: true,
    showOutdated: true,
    showInDudaEditor: true,
    showExtraAdviceForDudaEditor: false
  },
  gwt_queries: {
    isProjectOnly: true,
    isFree: false,
    showOutdated: false,
    showInDudaEditor: false,
    showExtraAdviceForDudaEditor: false
  }
};
